import httpClient from './httpClient';

const agencyService = {
    getAgence() {
        return httpClient.get('/api/adv/agence');
    },
    getTeamMembers(idAgency) {
        return httpClient.get(`/api/adv/agence/${idAgency}`);
    },
    getAgencyNews(pkAgency) {
        return httpClient.get(`https://blog.vitalliance.fr/wp-json/wp/v2/posts?agency=${pkAgency}&per_page=2`);
    },
    getFeaturedMedia(featuredMediaId) {
        return httpClient.get(`https://blog.vitalliance.fr/wp-json/wp/v2/media/${featuredMediaId}`);
    }
}

export default agencyService;